export const UPLOAD_DATA = 'UPLOAD_DATA'
export const CLEAR_UPLOAD_DATA = 'CLEAR_UPLOAD_DATA'
export const MATCH_UPLOAD_DATA = 'MATCH_UPLOAD_DATA'
export const UPLOAD_FINAL_DATA_START = 'UPLOAD_FINAL_DATA_START'
export const UPLOAD_FINAL_DATA_SUCCESS = 'UPLOAD_FINAL_DATA_SUCCESS'
export const UPLOAD_FINAL_DATA_FAILED = 'UPLOAD_FINAL_DATA_FAILED'
export const PARSED_FULL_ADDRESS = 'PARSED_FULL_ADDRESS'
export const DB_MATCH_START = 'DB_MATCH_START'
export const  DB_MATCH_SUCCESS = 'DB_MATCH_SUCCESS'
export const  DB_MATCH_FAIL = 'DB_MATCH_FAIL'
